"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlobalStyles = exports.getTheme = void 0;
const styles_1 = require("@mui/material/styles");
const locale_1 = require("@mui/material/locale");
const breakpoints_1 = __importDefault(require("./breakpoints"));
const overrides_1 = __importDefault(require("./overrides"));
const palette_1 = __importDefault(require("./palette"));
const shadows_1 = __importDefault(require("./shadows"));
const customShadows_1 = __importDefault(require("./customShadows"));
const typography_1 = __importDefault(require("./typography"));
const globalStyles_1 = __importDefault(require("./globalStyles"));
exports.GlobalStyles = globalStyles_1.default;
/**
 * Provider
 */
function getTheme(locale = locale_1.enUS, mode = 'light') {
    const isLight = mode === 'light';
    const themeOptions = {
        palette: isLight ? palette_1.default.light : palette_1.default.dark,
        typography: typography_1.default,
        breakpoints: breakpoints_1.default,
        shape: { borderRadius: 8 },
        direction: 'ltr',
        shadows: isLight ? shadows_1.default.light : shadows_1.default.dark,
        customShadows: (0, customShadows_1.default)(mode),
    };
    const theme = (0, styles_1.createTheme)(themeOptions, locale);
    theme.components = (0, overrides_1.default)(theme);
    return theme;
}
exports.getTheme = getTheme;
